module.exports = __webpack_public_path__ + "static/media/bill-to-ship-to-hide.725317c7.png";